import React from 'react';
import { Zap } from 'lucide-react';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}

export type EventNodeData = {
  id: string;
  summary: string;
  version: string;
  owners?: string[];
  sends?: string[];
  receives?: string[];
  name: string;
  specifications?: string[];
  repository?: {
    url: string;
  };
  styles?: {
    node: {
      color: string;
      label: string;
    };
    icon: string;
  };
  mode: 'simple' | 'full';
};

export interface EventNodeProps {
  id: string;
  data: EventNodeData;
  selected?: boolean;
}

export default function EventNode(props: EventNodeProps) {
  const { id, data, selected } = props;
  const { 
    version, 
    owners = [], 
    sends = [], 
    receives = [], 
    name, 
    mode, 
    summary 
  } = data;

  const nodeLabel = 'Event';

  return (
    <div className={classNames(
        "w-full rounded-md border flex justify-start bg-white text-black",
        selected ? "border-orange-600 ring-2 ring-orange-500 shadow-lg" : "border-orange-400"
      )}>
        <div
          className={`bg-gradient-to-b from-orange-500 to-orange-700 relative flex items-center w-5 justify-center rounded-l-sm text-orange-100 border-r-[1px] border-orange-500`}
        >
          <Zap className="w-4 h-4 opacity-90 text-white absolute top-1" />
          {mode === 'full' && (
            <span
              className={"rotate w-1/2 text-center absolute bottom-1 text-[8px] text-white font-bold uppercase tracking-[3px]"}
            >
              {nodeLabel}
            </span>
          )}
        </div>
        <div className="p-1 min-w-60 max-w-[min-content]">
          <div className={classNames(mode === 'full' ? `border-b border-gray-200` : '')}>
            <span className="text-xs font-bold block pt-0.5 pb-0.5">{name}</span>
            <div className="flex justify-between">
              <span className="text-[10px] font-light block pt-0.5 pb-0.5">v{version}</span>
              {mode === 'simple' && (
                <span className="text-[10px] text-gray-500 font-light block pt-0.5 pb-0.5">{nodeLabel}</span>
              )}
            </div>
          </div>
          {mode === 'full' && (
            <div className="divide-y divide-gray-200">
              <div className="leading-3 py-1">
                <span className="text-[8px] font-light">{summary}</span>
              </div>

              <div className="grid grid-cols-2 gap-x-4 py-1">
                <span className="text-xs" style={{ fontSize: '0.2em' }}>
                  Receives messages: {receives.length}
                </span>
                <span className="text-xs" style={{ fontSize: '0.2em' }}>
                  Publishes messages: {sends.length}
                </span>
                <span className="text-xs" style={{ fontSize: '0.2em' }}>
                  Owners: {owners.length}
                </span>
              </div>
            </div>
          )}
        </div>
    </div>
  );
}